import { defineStore } from 'pinia';
import type { ClientEmailState } from '~~/types/vuex/ClientEmail';

export const clientEmailStore = defineStore('clientEmail', {
  state: () => ({ clientEmail: '' as ClientEmailState['clientEmail'] | null }),
  actions: {
    setClientEmail(payload: ClientEmailState['clientEmail'] | null) {

      this.clientEmail = payload; 

    },
  },
});
